module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Object.keys(_vm.model).length) ? _c('v-form', {
    staticClass: "form form-horizontal with-divider",
    attrs: {
      "id": "priceStockForm"
    }
  }, [_c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.extra.isBD && _vm.extra.isDirectDeal && _vm.model.theatreWhiteList),
      expression: "extra.isBD && extra.isDirectDeal && model.theatreWhiteList"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_vm._v("产品类型设置")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-required col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("产品类型设置")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 pdt9"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.ticketPriceType),
      expression: "model.ticketPriceType"
    }],
    attrs: {
      "type": "radio",
      "disabled": !_vm.extra.isNew,
      "name": "ticketPriceType",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.model.ticketPriceType, "0")
    },
    on: {
      "__c": function($event) {
        _vm.model.ticketPriceType = "0"
      }
    }
  }), _vm._v("\n                    门票")]), _vm._v(" "), _c('label', {
    staticClass: "mgr10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.ticketPriceType),
      expression: "model.ticketPriceType"
    }],
    attrs: {
      "disabled": !_vm.extra.isNew,
      "type": "radio",
      "name": "ticketPriceType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.ticketPriceType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.ticketPriceType = "1"
      }
    }
  }), _vm._v("\n                    演出票")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.ticketPriceType == 1),
      expression: "model.ticketPriceType==1"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-required col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("是否支持在线选座")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 pdt9"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.canSeatSelection),
      expression: "model.canSeatSelection"
    }],
    attrs: {
      "type": "radio",
      "name": "canSeatSelection",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.model.canSeatSelection, "true")
    },
    on: {
      "__c": function($event) {
        _vm.model.canSeatSelection = "true"
      }
    }
  }), _vm._v("\n                    支持")]), _vm._v(" "), _c('label', {
    staticClass: "mgr10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.canSeatSelection),
      expression: "model.canSeatSelection"
    }],
    attrs: {
      "type": "radio",
      "name": "canSeatSelection",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.model.canSeatSelection, "false")
    },
    on: {
      "__c": function($event) {
        _vm.model.canSeatSelection = "false"
      }
    }
  }), _vm._v("\n                    不支持")])])])]), _vm._v(" "), _c('fieldset', {
    class: {
      'tuan-field': _vm.isTuan
    },
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [(_vm.extra.isDirectDeal) ? _c('div', {
    staticClass: "legend"
  }, [_vm._v("有效期设置  "), _c('span', {
    staticClass: "tip icon-info"
  }, [_vm._v("重要提示：有效期模式一经设置不能修改，请在上单前与商家确认")])]) : _c('div', {
    staticClass: "legend"
  }, [_vm._v("有效期设置  "), _c('span', {
    staticClass: "tip icon-info"
  }, [_vm._v("重要提示：有效期模式设置后不能修改")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-required col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v(_vm._s(_vm.model.IAmTheatre ? '有效期设置' : '日期设置'))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-lg-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.model.IAmTheatre),
      expression: "!model.IAmTheatre"
    }],
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.useDateMode),
      expression: "model.useDateMode"
    }],
    attrs: {
      "type": "radio",
      "value": "0",
      "disabled": _vm.mode == 'edit',
      "name": "dateMode"
    },
    domProps: {
      "checked": _vm._q(_vm.model.useDateMode, "0")
    },
    on: {
      "change": _vm.dateModeChange,
      "__c": function($event) {
        _vm.model.useDateMode = "0"
      }
    }
  }), _vm._v("有效期模式，无需用户指定使用日期\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.useDateMode),
      expression: "model.useDateMode"
    }],
    attrs: {
      "type": "radio",
      "value": "1",
      "disabled": _vm.mode == 'edit',
      "name": "dateMode"
    },
    domProps: {
      "checked": _vm._q(_vm.model.useDateMode, "1")
    },
    on: {
      "change": _vm.dateModeChange,
      "__c": function($event) {
        _vm.model.useDateMode = "1"
      }
    }
  }), _vm._v("\n                        使用日期模式，需要用户指定使用日期，自所选日期起\n                        "), _c('span', {
    staticClass: "inline-block input-w-3 relative"
  }, [_c('custom-input-number', {
    staticStyle: {
      "position": "absolute",
      "top": "-26px"
    },
    attrs: {
      "min": 1,
      "step": 1,
      "disabled": _vm.model.useDateMode == 0
    },
    model: {
      value: (_vm.model.useDateDays),
      callback: function($$v) {
        _vm.model.useDateDays = $$v
      },
      expression: "model.useDateDays"
    }
  })], 1), _vm._v("\n                        天内可使用\n                    ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.useDateMode == 1 && !_vm.model.IAmTheatre),
      expression: "model.useDateMode==1 && !model.IAmTheatre"
    }],
    staticClass: "inline-block annotate"
  }, [_vm._v("与无需指定日期相比，订单量约减少20%")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.useDateMode == 1 && !_vm.model.useDateDays),
      expression: "needValidation && model.useDateMode == 1 && !model.useDateDays"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                    请填写几日内可使用")])])]), _vm._v(" "), (_vm.model.useDateMode == 0 && !_vm.model.IAmTheatre) ? _c('div', [_c('div', {
    staticClass: "form-group",
    attrs: {
      "fieldset-validator": "'checkGroup'"
    }
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("有效期时间段")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 input-w-4"
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.voucherDateBeginEnd,
      "options": _vm.inDateOption
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.useDateMode == 0 && !_vm.model.voucherDateBegin),
      expression: "needValidation && model.useDateMode == 0 && !model.voucherDateBegin"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("请选择有效期时间段")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "ng-class": "{'has-warning': (validWeekRuleForm.$invalid) && $ctrl.needValidation}"
    }
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("可用日期")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "checkbox-group pdt9"
  }, [_vm._l((_vm.weeks), function(i) {
    return _c('label', {
      key: i.val
    }, [(_vm.model.validWeekRule) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.model.validWeekRule[i.val]),
        expression: "model.validWeekRule[i.val]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "true"
      },
      domProps: {
        "checked": Array.isArray(_vm.model.validWeekRule[i.val]) ? _vm._i(_vm.model.validWeekRule[i.val], "true") > -1 : (_vm.model.validWeekRule[i.val])
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.model.validWeekRule[i.val],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "true",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.model.validWeekRule[i.val] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.model.validWeekRule[i.val] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.model.validWeekRule, i.val, $$c)
          }
        }
      }
    }) : _vm._e(), _vm._v(_vm._s(i.text))])
  }), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.validWeekCheckedAll),
      expression: "validWeekCheckedAll"
    }],
    attrs: {
      "type": "checkbox",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.validWeekCheckedAll) ? _vm._i(_vm.validWeekCheckedAll, "true") > -1 : (_vm.validWeekCheckedAll)
    },
    on: {
      "change": _vm.selectAllWeek,
      "__c": function($event) {
        var $$a = _vm.validWeekCheckedAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.validWeekCheckedAll = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.validWeekCheckedAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.validWeekCheckedAll = $$c
        }
      }
    }
  }), _vm._v("全选")])], 2), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.useDateMode == 0 && !_vm.hasWeekOne),
      expression: "needValidation && model.useDateMode == 0 && !hasWeekOne"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                        请选择可用日期")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-lg-2 col-sm-3"
  }, [_vm._v("不可用日期")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 bd minh249 pd10",
    staticStyle: {
      "margin-top": "1px"
    }
  }, _vm._l((_vm.model.unavailableDates), function(i) {
    return _c('span', {
      class: {
        'disable-date': true, 'mg10': true, 'disabled': i < _vm.today
      }
    }, [_vm._v(_vm._s(i) + "\n                    "), _c('span', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.mode !== 'readonly' && _vm.deleteUnavailableDates(i)
        }
      }
    }, [_vm._v("x")])])
  })), _vm._v(" "), (!_vm.isTuan) ? _c('div', {
    staticClass: "col-sm-4 no-input"
  }, [(Object.keys(_vm.model).length) ? _c('custom-datepicker', {
    attrs: {
      "message": _vm.unavailableDates,
      "options": _vm.inDateOptionOpen
    },
    on: {
      "update:options": function($event) {
        _vm.inDateOptionOpen = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-link no-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetUnavailableDates
    }
  }, [_vm._v("重置不可用日期\n                        ")])])], 1) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.model.IAmTheatre),
      expression: "!model.IAmTheatre"
    }]
  }, [(_vm.model.useDateMode == 0) ? _c('div', [_c('div', {
    staticClass: "legend"
  }, [_vm._v("价格库存")]), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("库存模式")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 pdt9"
  }, [_c('label', {
    attrs: {
      "for": "r11"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.stockType),
      expression: "model.stockType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "id": "r11",
      "type": "radio",
      "name": "stockType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.stockType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.stockType = "1"
      }
    }
  }), _vm._v("\n                            不限库存")]), _vm._v(" "), _c('label', {
    staticClass: "mgr10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.stockType),
      expression: "model.stockType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "type": "radio",
      "name": "stockType",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.model.stockType, "3")
    },
    on: {
      "__c": function($event) {
        _vm.model.stockType = "3"
      }
    }
  }), _vm._v("\n                            总库存")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.stockType == 3),
      expression: "model.stockType==3"
    }]
  }, [_vm._v("\n                    剩余总库存\n                "), _c('span', {
    staticClass: "inline-block input-w-3 relative"
  }, [_c('custom-input-number', {
    staticStyle: {
      "position": "absolute",
      "top": "-26px"
    },
    attrs: {
      "min": 0,
      "step": 1
    },
    model: {
      value: (_vm.model.stock),
      callback: function($$v) {
        _vm.model.stock = $$v
      },
      expression: "model.stock"
    }
  })], 1), _vm._v("\n                张 已售" + _vm._s(_vm.model.sold || 0) + "张\n                ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.stockType == 3 && !_vm.model.stock),
      expression: "needValidation && model.stockType == 3 && !model.stock"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                            请填写剩余总库存")])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("价格设置")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', [_c('table', {
    staticClass: "table table-bordered table-centered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("门市价(元)")]), _vm._v(" "), _c('th', [_vm._v("美团价(元)")]), _vm._v(" "), _c('th', [_vm._v("结算价(元)")]), _vm._v(" "), _c('th', [_vm._v("费率(%)")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('custom-input-number', {
    attrs: {
      "placeholder": '请输入门市价',
      "min": 0,
      "step": 0.01,
      "disabled": _vm.mode == 'readonly'
    },
    model: {
      value: (_vm.model.marketPrice),
      callback: function($$v) {
        _vm.model.marketPrice = $$v
      },
      expression: "model.marketPrice"
    }
  })], 1), _vm._v(" "), _c('td', [_c('custom-input-number', {
    attrs: {
      "placeholder": '请输入美团价',
      "min": 0,
      "step": 0.01,
      "disabled": _vm.mode == 'readonly'
    },
    model: {
      value: (_vm.model.mtPrice),
      callback: function($$v) {
        _vm.model.mtPrice = $$v
      },
      expression: "model.mtPrice"
    }
  })], 1), _c('td', [_c('custom-input-number', {
    attrs: {
      "initAsNull": true,
      "placeholder": '请输入结算价',
      "min": 0,
      "disabled": _vm.mode == 'readonly',
      "step": 0.01
    },
    model: {
      value: (_vm.model.settlementPrice),
      callback: function($$v) {
        _vm.model.settlementPrice = $$v
      },
      expression: "model.settlementPrice"
    }
  })], 1), _c('td', {
    staticClass: "disabled"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ratioShow),
      expression: "ratioShow"
    }],
    class: {
      'red': _vm.ratioInvalid, 'no-border-input': true
    },
    attrs: {
      "readonly": "",
      "name": "ratio",
      "type": "text"
    },
    domProps: {
      "value": (_vm.ratioShow)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ratioShow = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "red"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.mtPrice > _vm.model.marketPrice),
      expression: "model.mtPrice > model.marketPrice"
    }]
  }, [_vm._v("美团价不能大于门市价")]), _vm._v(" "), (_vm.ratio > 50 || _vm.ratioInvalid == 4) ? _c('span', [_vm._v("请确认您是否输入了正确的价格 " + _vm._s(_vm.ratioInvalid == 4 ? '<' + (this.model.onlineMsRatioPriceInfo.oldMsRatio * 100) + '% 费率下降' : ''))]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.settlementPrice && _vm.ratio < _vm.model.baseMsRatioSnapshot * 100),
      expression: "model.settlementPrice && ratio < model.baseMsRatioSnapshot*100"
    }]
  }, [_vm._v("\n                                          重要提示：费率低于当前【" + _vm._s(_vm.model.maxMsRatioProvinceName) + "】的底线费率" + _vm._s(_vm.model.baseMsRatioSnapshot * 100) + "%")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.useDateMode == 0 && (!_vm.model.marketPrice || !_vm.model.mtPrice)),
      expression: "needValidation && model.useDateMode == 0 && (!model.marketPrice || !model.mtPrice)"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                                请填写价格信息")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.model.useDateMode != 0) ? _c('div', [_c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_vm._v("价格库存")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("库存模式")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 pdt9"
  }, [_c('label', {
    attrs: {
      "for": "r11"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.stockType),
      expression: "model.stockType"
    }],
    attrs: {
      "type": "radio",
      "disabled": _vm.mode == 'readonly',
      "name": "stockType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.stockType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.stockType = "1"
      }
    }
  }), _vm._v("\n                            不限库存")]), _vm._v(" "), _c('label', {
    staticClass: "mgr10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.stockType),
      expression: "model.stockType"
    }],
    attrs: {
      "type": "radio",
      "disabled": _vm.mode == 'readonly',
      "name": "stockType",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.model.stockType, "3")
    },
    on: {
      "__c": function($event) {
        _vm.model.stockType = "3"
      }
    }
  }), _vm._v("\n                            总库存")]), _vm._v(" "), _c('label', {
    staticClass: "mgr10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.stockType),
      expression: "model.stockType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "type": "radio",
      "name": "stockType",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.model.stockType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.model.stockType = "2"
      }
    }
  }), _vm._v("\n                            日库存")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.stockType == 3),
      expression: "model.stockType==3"
    }]
  }, [_vm._v("\n                    剩余总库存\n                "), _c('span', {
    staticClass: "inline-block input-w-3 relative"
  }, [_c('custom-input-number', {
    staticStyle: {
      "position": "absolute",
      "top": "-26px"
    },
    attrs: {
      "min": 0,
      "step": 1
    },
    model: {
      value: (_vm.model.stock),
      callback: function($$v) {
        _vm.model.stock = $$v
      },
      expression: "model.stock"
    }
  })], 1), _vm._v("\n                张 已售 " + _vm._s(_vm.model.sold || 0) + " 张\n                ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.stockType == 3 && !_vm.model.stock),
      expression: "needValidation && model.stockType == 3 && !model.stock"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                            请填写剩余总库存")])])])]), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [(_vm.canPullPrice && _vm.model.useDateMode == 1) ? _c('button', {
    staticClass: "btn btn-primary pull-price-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pullPrice(true)
      }
    }
  }, [_vm._v("\n                            拉取价格信息\n                        ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("日期价格")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('label', {
    staticClass: "control-label label-require"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("请先选择日期")]), _vm._v(" "), _c('Calendar', {
    attrs: {
      "selected": _vm.dateSelected,
      "single": false,
      "lock-check": _vm.dayLock.bind(this),
      "readonly": _vm.mode == 'readonly',
      "isTuan": _vm.isTuan,
      "get-day-info": _vm.getInfoFun.bind(this),
      "before-time": _vm.today
    },
    on: {
      "update:selected": function($event) {
        _vm.dateSelected = $event
      },
      "calendar-remove-selected": _vm.onRemoveDate
    }
  })], 1), _vm._v(" "), (!_vm.isTuan) ? _c('div', {
    staticClass: "col-sm-9 col-md-offset-2",
    staticStyle: {
      "padding": "0",
      "padding-top": "10px"
    }
  }, [(!(_vm.canPullPrice && _vm.model.useDateMode == 1)) ? _c('div', {
    staticStyle: {
      "margin-left": "13px"
    }
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("价格设置\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [(!(_vm.canPullPrice && _vm.model.useDateMode == 1)) ? _c('table', {
    staticClass: "table table-bordered table-centered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("门市价(元)")]), _vm._v(" "), _c('th', [_vm._v("美团价(元)")]), _vm._v(" "), _c('th', [_vm._v("结算价(元)")]), _vm._v(" "), _c('th', [_vm._v("费率(%)")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('custom-input-number', {
    attrs: {
      "placeholder": '请输入门市价',
      "min": 0,
      "step": 0.01,
      "disabled": _vm.mode == 'readonly'
    },
    model: {
      value: (_vm.modelLocal.marketPrice),
      callback: function($$v) {
        _vm.modelLocal.marketPrice = $$v
      },
      expression: "modelLocal.marketPrice"
    }
  })], 1), _vm._v(" "), _c('td', [_c('custom-input-number', {
    attrs: {
      "placeholder": '请输入美团价',
      "min": 0,
      "step": 0.01,
      "disabled": _vm.mode == 'readonly'
    },
    model: {
      value: (_vm.modelLocal.mtPrice),
      callback: function($$v) {
        _vm.modelLocal.mtPrice = $$v
      },
      expression: "modelLocal.mtPrice"
    }
  })], 1), _vm._v(" "), _c('td', [_c('custom-input-number', {
    attrs: {
      "placeholder": '请输入结算价',
      "min": 0,
      "step": 0.01,
      "disabled": _vm.mode == 'readonly',
      "initAsNull": true
    },
    model: {
      value: (_vm.modelLocal.settlementPrice),
      callback: function($$v) {
        _vm.modelLocal.settlementPrice = $$v
      },
      expression: "modelLocal.settlementPrice"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "disabled"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ratioShowLocal),
      expression: "ratioShowLocal"
    }],
    class: {
      'red': _vm.ratioInvalid || _vm.belowBase, 'no-border-input': true
    },
    attrs: {
      "readonly": "",
      "name": "ratio",
      "type": "text"
    },
    domProps: {
      "value": (_vm.ratioShowLocal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ratioShowLocal = $event.target.value
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "red"
  }, [(_vm.ratioLocal > 50 || _vm.modelLocal.settlementPrice && _vm.hasDeclined) ? _c('span', [_vm._v("请确认您是否输入了正确的价格 " + _vm._s(_vm.modelLocal.settlementPrice && _vm.hasDeclined ? '费率下降' : ''))]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modelLocal.mtPrice > _vm.modelLocal.marketPrice),
      expression: "modelLocal.mtPrice > modelLocal.marketPrice"
    }]
  }, [_vm._v("美团价不能大于门市价")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modelLocal.settlementPrice && _vm.ratioLocal < _vm.model.baseMsRatioSnapshot * 100),
      expression: "modelLocal.settlementPrice && ratioLocal < model.baseMsRatioSnapshot * 100"
    }]
  }, [_vm._v("\n                                          低于当前【" + _vm._s(_vm.model.maxMsRatioProvinceName) + "】的底线费率" + _vm._s(_vm.model.baseMsRatioSnapshot * 100) + "%")])]), _vm._v(" "), (_vm.belowBase) ? _c('table', {
    staticClass: "table table-bordered table-centered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                                        特殊费率详细信息\n                                        "), _c('span', {
    staticClass: "red"
  }, [_vm._v("当前【" + _vm._s(_vm.model.maxMsRatioProvinceName) + "】底线费率" + _vm._s(_vm.model.baseMsRatioSnapshot * 100) + "%")])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("日期")]), _vm._v(" "), _c('th', [_vm._v("美团价")]), _vm._v(" "), _c('th', [_vm._v("费率")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.invalidRatioList), function(group) {
    return _c('tr', [_c('td', [_c('ul', {
      staticClass: "list-unstyled"
    }, _vm._l((group.dates), function(item) {
      return _c('li', [_vm._v(_vm._s(item))])
    }))]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(group.mtPrice) + "\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(group.ratio) + "%\n                                    ")])])
  }))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!(_vm.canPullPrice && _vm.model.useDateMode == 1)) ? _c('div', {
    staticClass: "col-sm-6 col-md-offset-2 pdt9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.stockType == 2),
      expression: "model.stockType==2"
    }]
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("剩余日库存\n                     "), _c('span', {
    staticClass: "inline-block input-w-3 relative"
  }, [_c('custom-input-number', {
    staticStyle: {
      "position": "absolute",
      "top": "-26px"
    },
    attrs: {
      "min": 0,
      "step": 1
    },
    model: {
      value: (_vm.modelLocal.stock),
      callback: function($$v) {
        _vm.modelLocal.stock = $$v
      },
      expression: "modelLocal.stock"
    }
  })], 1), _vm._v("\n                    张  \n                    ")]), _vm._v(" "), (!_vm.readonly || _vm.isTuan) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.modelLocal.marketPrice || !_vm.modelLocal.mtPrice || _vm.modelLocal.settlementPrice == undefined
    },
    on: {
      "click": function($event) {
        _vm.addDayPrice(_vm.modelLocal, _vm.dateSelected)
      }
    }
  }, [_vm._v("更新\n                        ")]) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.model.useDateMode == 0 && _vm.model.settlementPrice == 0) || (_vm.modelLocal.settlementPrice == 0 && _vm.model.useDateMode != 0) || _vm.foundFreeTicket),
      expression: "(model.useDateMode ==0 && model.settlementPrice == 0) || (modelLocal.settlementPrice==0 && model.useDateMode !=0) || foundFreeTicket"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("免票类型")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('v-select', {
    attrs: {
      "clearable": false,
      "size": "md",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.updateFreeType
    },
    model: {
      value: (_vm.model.freeTicketType),
      callback: function($$v) {
        _vm.model.freeTicketType = $$v
      },
      expression: "model.freeTicketType"
    }
  }, _vm._l((_vm.freeTicketTypes), function(item) {
    return _c('v-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.freeTicketType == 0),
      expression: "model.freeTicketType==0"
    }]
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("关联账单")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('v-select', {
    class: {
      'has-warning': !_vm.model.statementId
    },
    attrs: {
      "clearable": false,
      "size": "md",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.updateStatements
    },
    model: {
      value: (_vm.model.statementId),
      callback: function($$v) {
        _vm.model.statementId = $$v
      },
      expression: "model.statementId"
    }
  }, _vm._l((_vm.model.associatedContractList), function(item) {
    return _c('v-option', {
      key: item.statementId,
      attrs: {
        "label": item.showName,
        "value": item.statementId + ''
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.freeTicketType == 1),
      expression: "model.freeTicketType==1"
    }]
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("关联广告合同编号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.freeTicketAssociatedAccount),
      expression: "model.freeTicketAssociatedAccount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "freeTicketAssociatedAccount",
      "id": "freeTicketAssociatedAccount",
      "placeholder": "关联合同编号"
    },
    domProps: {
      "value": (_vm.model.freeTicketAssociatedAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.freeTicketAssociatedAccount = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && ((_vm.model.useDateMode == 0 && _vm.model.settlementPrice == 0) || (_vm.modelLocal.settlementPrice == 0 && _vm.model.useDateMode != 0) || _vm.foundFreeTicket) && (_vm.model.freeTicketType == null || _vm.model.freeTicketType == undefined)),
      expression: "needValidation && ((model.useDateMode ==0 && model.settlementPrice == 0) || (modelLocal.settlementPrice==0 && model.useDateMode !=0) || foundFreeTicket) && (model.freeTicketType==null || model.freeTicketType==undefined)"
    }],
    staticClass: "warning-msg  col-lg-offset-2 col-sm-offset-3",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_vm._v("\n                请选择免票类型")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.model.useDateMode == 0 && _vm.model.settlementPrice == 0) || (_vm.modelLocal.settlementPrice == 0 && _vm.model.useDateMode != 0) || _vm.foundFreeTicket),
      expression: "(model.useDateMode ==0 && model.settlementPrice == 0) || (modelLocal.settlementPrice==0 && model.useDateMode !=0) || foundFreeTicket"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.freeTicketType == 4),
      expression: "model.freeTicketType == 4"
    }],
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("免票备注")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.freeTicketRemarks),
      expression: "model.freeTicketRemarks"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "freeTicketRemarks",
      "id": "include",
      "cols": "30",
      "rows": "5",
      "placeholder": "请填写免票备注的详细信息"
    },
    domProps: {
      "value": (_vm.model.freeTicketRemarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.freeTicketRemarks = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && ((_vm.model.useDateMode == 0 && _vm.model.settlementPrice == 0) || (_vm.modelLocal.settlementPrice == 0 && _vm.model.useDateMode != 0) || _vm.foundFreeTicket) && _vm.model.freeTicketType == 4),
      expression: "needValidation && ((model.useDateMode ==0 && model.settlementPrice == 0) || (modelLocal.settlementPrice==0 && model.useDateMode !=0) || foundFreeTicket) && model.freeTicketType == 4"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                        请填写免票备注")])])]), _vm._v(" "), ((_vm.model.useDateMode == 0 && (_vm.ratioInvalid == 4 || _vm.ratioInvalid == 3)) || (_vm.model.useDateMode == 1 && (_vm.hasDeclined || _vm.belowBase))) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-2 control-label label-require"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("特殊费率原因：")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('table', {
    staticClass: "rate-reason margin-left15"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.specialMsRatioReasonType),
      expression: "model.specialMsRatioReasonType"
    }],
    attrs: {
      "type": "radio",
      "name": "specialMsRatioReasonType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.specialMsRatioReasonType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.specialMsRatioReasonType = "1"
      }
    }
  }), _vm._v("同行价格劣势竞争\n                                        ")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.specialMsRatioReasonType),
      expression: "model.specialMsRatioReasonType"
    }],
    attrs: {
      "type": "radio",
      "name": "specialMsRatioReasonType",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.model.specialMsRatioReasonType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.model.specialMsRatioReasonType = "2"
      }
    }
  }), _vm._v("独家优势方案、资源、票种\n                                        ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.specialMsRatioReasonType),
      expression: "model.specialMsRatioReasonType"
    }],
    attrs: {
      "type": "radio",
      "name": "specialMsRatioReasonType",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.model.specialMsRatioReasonType, "3")
    },
    on: {
      "__c": function($event) {
        _vm.model.specialMsRatioReasonType = "3"
      }
    }
  }), _vm._v("结算价格不变且无法使用促销\n                                        ")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.specialMsRatioReasonType),
      expression: "model.specialMsRatioReasonType"
    }],
    attrs: {
      "type": "radio",
      "name": "specialMsRatioReasonType",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.model.specialMsRatioReasonType, "4")
    },
    on: {
      "__c": function($event) {
        _vm.model.specialMsRatioReasonType = "4"
      }
    }
  }), _vm._v("其他（请在下方文本框中填写理由）\n                                        ")])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.specialMsRatioReasonType == '4'),
      expression: "model.specialMsRatioReasonType == '4'"
    }],
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.specialMsRatioReason),
      expression: "model.specialMsRatioReason"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "rows": "3",
      "maxlength": "100",
      "placeholder": "请填写特殊费率原因"
    },
    domProps: {
      "value": (_vm.model.specialMsRatioReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.specialMsRatioReason = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      red: _vm.model.specialMsRatioReason.length == 100
    }
  }, [_vm._v(_vm._s(_vm.model.specialMsRatioReason.length || 0) + "/100字")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.specialMsRatioReasonType == '4' && !_vm.model.specialMsRatioReason),
      expression: "needValidation && model.specialMsRatioReasonType == '4' && !model.specialMsRatioReason"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                        请填写特殊费率原因")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.IAmTheatre),
      expression: "model.IAmTheatre"
    }]
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_vm._v("演出设置\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "-50px"
    }
  }, [_c('div', {
    staticClass: "col-sm-8 col-sm-offset-1"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !(_vm.extra.partnerDealId && _vm.extra.supplierId),
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.fetchTheatreInfo(true)
      }
    }
  }, [_vm._v("拉取演出信息")]), _vm._v(" "), _c('v-tabs', {
    staticClass: "no-fixed",
    attrs: {
      "type": "panels"
    },
    on: {
      "tab-click": function($event) {}
    }
  }, [_c('v-tab-pane', {
    attrs: {
      "label": "1.价格日历"
    }
  }, [_c('Calendar', {
    attrs: {
      "selected": _vm.price.dateSelected,
      "single": !_vm.price.canEditPrice,
      "lock-check": _vm.dayLock.bind(this),
      "on-single-select": _vm.price.onDaySelect,
      "readonly": _vm.mode == 'readonly' && false,
      "get-day-info": _vm.price.getInfoFun.bind(this),
      "before-time": _vm.today
    },
    on: {
      "update:selected": function($event) {
        _vm.price.dateSelected = $event
      }
    }
  }), _vm._v(" "), (_vm.mode == 'edit' || _vm.mode == 'readonly' || _vm.mode == 'new' || _vm.mode == 'copy') ? _c('div', [_c('div', [_c('p', [_vm._v(_vm._s(!_vm.price.canEditPrice && !_vm.price.dateSelected.length ? '请选择日期以查看价格' : ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(!_vm.price.canEditPrice && _vm.price.dateSelected.length ? '已选择：' + _vm.price.dateSelected[0] :
    ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.price.canEditPrice ? '已选择: ' + _vm.price.dateSelected.length + '天' : ''))])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-centered input-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("市场价(元)")]), _vm._v(" "), _c('th', [_vm._v("美团价(元)")]), _vm._v(" "), _c('th', [_vm._v("结算价(元)")]), _vm._v(" "), _c('th', [_vm._v("费率(%)")]), _vm._v(" "), _c('th', [_vm._v("价格说明")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "juchang"
  }, _vm._l((_vm.price.priceTable), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('custom-input-number', {
      attrs: {
        "placeholder": '请输入门市价',
        "min": 0,
        "step": 0.01,
        "disabled": !_vm.price.canEditPrice
      },
      model: {
        value: (item.marketPrice),
        callback: function($$v) {
          item.marketPrice = $$v
        },
        expression: "item.marketPrice"
      }
    })], 1), _vm._v(" "), _c('td', [_c('custom-input-number', {
      attrs: {
        "placeholder": '请输入美团价',
        "min": 0,
        "step": 0.01,
        "disabled": !_vm.price.canEditPrice
      },
      model: {
        value: (item.mtPrice),
        callback: function($$v) {
          item.mtPrice = $$v
        },
        expression: "item.mtPrice"
      }
    })], 1), _vm._v(" "), _c('td', [_c('custom-input-number', {
      attrs: {
        "placeholder": '请输入结算价',
        "min": 0,
        "disabled": !_vm.price.canEditPrice,
        "step": 0.01
      },
      model: {
        value: (item.settlementPrice),
        callback: function($$v) {
          item.settlementPrice = $$v
        },
        expression: "item.settlementPrice"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "disabled"
    }, [_vm._v("\n                                        " + _vm._s(_vm.correctRatio(item.mtPrice, item.settlementPrice)) + "\n                                    ")]), _vm._v(" "), _c('td', {
      staticClass: "disabled"
    }, [_vm._v("\n                                        " + _vm._s(item.priceDesc) + "\n                                    ")])])
  }))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 'edit' || _vm.mode == 'new' || _vm.mode == 'copy' || _vm.mode == 'readonly'),
      expression: "mode == 'edit' || mode == 'new' || mode == 'copy' || mode == 'readonly'"
    }]
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.price.canEditPrice),
      expression: "!price.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.mode == 'readonly'
    },
    on: {
      "click": function($event) {
        _vm.price.canEditPrice = true;
      }
    }
  }, [_vm._v("编辑\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.price.canEditPrice),
      expression: "price.canEditPrice"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.price.cancelCanEdit
    }
  }, [_vm._v("取消\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.price.canEditPrice),
      expression: "price.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.price.savePrice
    }
  }, [_vm._v("保存\n                                ")])])], 1), _vm._v(" "), _c('v-tab-pane', {
    attrs: {
      "label": "2.场次信息",
      "hidden": !_vm.theatreTab.changci
    }
  }, [_c('Calendar', {
    attrs: {
      "selected": _vm.changci.dateSelected,
      "single": !_vm.changci.canEditPrice,
      "lock-check": _vm.dayLock.bind(this),
      "on-single-select": _vm.changci.onDaySelect,
      "readonly": _vm.mode == 'readonly' && false,
      "get-day-info": _vm.changci.getInfoFun.bind(this),
      "before-time": _vm.today
    },
    on: {
      "update:selected": function($event) {
        _vm.changci.dateSelected = $event
      }
    }
  }), _vm._v(" "), (_vm.mode == 'edit' || _vm.mode == 'new' || _vm.mode == 'readonly' || _vm.mode == 'copy') ? _c('div', [_c('div', [_c('p', [_vm._v(_vm._s(!_vm.changci.canEditPrice && !_vm.changci.dateSelected.length ? '请选择日期以查看场次信息' : ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(!_vm.changci.canEditPrice && _vm.changci.dateSelected.length ? '已选择：' + _vm.changci.dateSelected[0] :
    ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.changci.canEditPrice ? '已选择: ' + _vm.changci.dateSelected.length + '天' : ''))])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-centered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("场次信息")]), _vm._v(" "), _c('th', [_vm._v("场次开始时间")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "juchang"
  }, _vm._l((_vm.changci.priceTable), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('v-input', {
      attrs: {
        "placeholder": "'请输入场次信息'",
        "disabled": !_vm.changci.canEditPrice
      },
      model: {
        value: (item.levelName),
        callback: function($$v) {
          item.levelName = $$v
        },
        expression: "item.levelName"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(item.mappingRel) + "\n                                    ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sort-dialog",
    on: {
      "click": function($event) {
        _vm.sortDialog.sort('changci')
      }
    }
  }, [_vm._v("调整顺序"), _c('span', {
    staticClass: "sort-icon"
  })]), _vm._v(" "), _c('p', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.changci.canEditPrice),
      expression: "!changci.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.mode == 'readonly'
    },
    on: {
      "click": function($event) {
        _vm.changci.canEditPrice = true;
      }
    }
  }, [_vm._v("编辑\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changci.canEditPrice),
      expression: "changci.canEditPrice"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changci.cancelCanEdit
    }
  }, [_vm._v("取消\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changci.canEditPrice),
      expression: "changci.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changci.savePrice
    }
  }, [_vm._v("保存\n                                ")])])], 1), _vm._v(" "), _c('v-tab-pane', {
    attrs: {
      "label": "3.席位信息",
      "hidden": !_vm.theatreTab.xiwei
    }
  }, [_c('Calendar', {
    attrs: {
      "selected": _vm.xiwei.dateSelected,
      "single": !_vm.xiwei.canEditPrice,
      "lock-check": _vm.dayLock.bind(this),
      "on-single-select": _vm.xiwei.onDaySelect,
      "readonly": _vm.mode == 'readonly' && false,
      "get-day-info": _vm.xiwei.getInfoFun.bind(this),
      "before-time": _vm.today
    },
    on: {
      "update:selected": function($event) {
        _vm.xiwei.dateSelected = $event
      }
    }
  }), _vm._v(" "), (_vm.mode == 'edit' || _vm.mode == 'new' || _vm.mode == 'readonly' || _vm.mode == 'copy') ? _c('div', [_c('div', [_c('p', [_vm._v(_vm._s(!_vm.xiwei.canEditPrice && !_vm.xiwei.dateSelected.length ? '请选择日期以查看席位信息' : ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(!_vm.xiwei.canEditPrice && _vm.xiwei.dateSelected.length ? '已选择：' + _vm.xiwei.dateSelected[0] :
    ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.xiwei.canEditPrice ? '已选择: ' + _vm.xiwei.dateSelected.length + '天' : ''))])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-centered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("坐席信息")]), _vm._v(" "), _c('th', [_vm._v("坐席位置")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "juchang"
  }, _vm._l((_vm.xiwei.priceTable), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('v-input', {
      attrs: {
        "placeholder": "'请输入席位信息'",
        "disabled": !_vm.xiwei.canEditPrice
      },
      model: {
        value: (item.levelName),
        callback: function($$v) {
          item.levelName = $$v
        },
        expression: "item.levelName"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(item.mappingRel) + "\n                                    ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sort-dialog",
    on: {
      "click": function($event) {
        _vm.sortDialog.sort('xiwei')
      }
    }
  }, [_vm._v("调整顺序"), _c('span', {
    staticClass: "sort-icon"
  })]), _vm._v(" "), _c('p', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.xiwei.canEditPrice),
      expression: "!xiwei.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.mode == 'readonly'
    },
    on: {
      "click": function($event) {
        _vm.xiwei.canEditPrice = true;
      }
    }
  }, [_vm._v("编辑\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.xiwei.canEditPrice),
      expression: "xiwei.canEditPrice"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.xiwei.cancelCanEdit
    }
  }, [_vm._v("取消\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.xiwei.canEditPrice),
      expression: "xiwei.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.xiwei.savePrice
    }
  }, [_vm._v("保存\n                                ")])])], 1), _vm._v(" "), _c('v-tab-pane', {
    attrs: {
      "label": "4.场馆区域",
      "hidden": !_vm.theatreTab.changguan
    }
  }, [_c('Calendar', {
    attrs: {
      "selected": _vm.changguan.dateSelected,
      "single": !_vm.changguan.canEditPrice,
      "lock-check": _vm.dayLock.bind(this),
      "on-single-select": _vm.changguan.onDaySelect,
      "readonly": _vm.mode == 'readonly' && false,
      "get-day-info": _vm.changguan.getInfoFun.bind(this),
      "before-time": _vm.today
    },
    on: {
      "update:selected": function($event) {
        _vm.changguan.dateSelected = $event
      }
    }
  }), _vm._v(" "), (_vm.mode == 'edit' || _vm.mode == 'new' || _vm.mode == 'readonly' || _vm.mode == 'copy') ? _c('div', [_c('div', [_c('p', [_vm._v(_vm._s(!_vm.changguan.canEditPrice && !_vm.changguan.dateSelected.length ? '请选择日期以查看场馆信息' : ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(!_vm.changguan.canEditPrice && _vm.changguan.dateSelected.length ? '已选择：' + _vm.changguan.dateSelected[0] :
    ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.changguan.canEditPrice ? '已选择: ' + _vm.changguan.dateSelected.length + '天' : ''))])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-centered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("场馆区域信息")]), _vm._v(" "), _c('th', [_vm._v("场馆位置")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "juchang"
  }, _vm._l((_vm.changguan.priceTable), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('v-input', {
      attrs: {
        "placeholder": "'请输入场馆区域信息'",
        "disabled": !_vm.changguan.canEditPric
      },
      model: {
        value: (item.levelName),
        callback: function($$v) {
          item.levelName = $$v
        },
        expression: "item.levelName"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(item.mappingRel) + "\n                                    ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sort-dialog",
    on: {
      "click": function($event) {
        _vm.sortDialog.sort('changguan')
      }
    }
  }, [_vm._v("调整顺序"), _c('span', {
    staticClass: "sort-icon"
  })]), _vm._v(" "), _c('p', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.changguan.canEditPrice),
      expression: "!changguan.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.mode == 'readonly'
    },
    on: {
      "click": function($event) {
        _vm.changguan.canEditPrice = true;
      }
    }
  }, [_vm._v("编辑\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changguan.canEditPrice),
      expression: "changguan.canEditPrice"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changguan.cancelCanEdit
    }
  }, [_vm._v("取消\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changguan.canEditPrice),
      expression: "changguan.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changguan.savePrice
    }
  }, [_vm._v("保存\n                                ")])])], 1)], 1)], 1)])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_vm._v("座位图片")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-8 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "pdt9"
  }, [_c('custom-upload', {
    attrs: {
      "url": _vm.seatUpload.url,
      "file-name": 'file',
      "is-multiple": false,
      "max-limit": _vm.seatUpload.maxImgLength,
      "thumbnail-mode": true,
      "show-file-list": false,
      "type": 'imageList',
      "default-file-list": _vm.model.seatImageShow,
      "fileLimitSize": 2097152,
      "enable-head-image": false,
      "accept": 'image/jpg,image/jpeg,image/png'
    },
    on: {
      "on-max-limit": _vm.seatUpload.onMaxLimit,
      "on-success": _vm.seatUpload.onSuccess,
      "on-delete": _vm.seatUpload.onDelete,
      "on-file-size-max-limit": _vm.seatUpload.onSizeLimited
    }
  })], 1), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "pdt9 lh14"
  }, [_c('b', [_vm._v("注意事项：")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "annotate"
  }, [_vm._v("\n                                  1. 高度和宽度不低于440px，图片大小不超过2M，支持格式有jpg、png、jpeg"), _c('br'), _vm._v("\n                            2. 重要提示：图片不可有字、不可使用拼图、不可有重复图片、不可有除美团水印外的其他水印、不能有人物特写、明星宣传画等涉及人物肖像权的图片"), _c('br')])])])])])])]), _vm._v(" "), _c('refund', {
    attrs: {
      "model": _vm.model,
      "mode": _vm.mode,
      "isTuan": _vm.isTuan,
      "extra": _vm.extra
    }
  }), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_vm._v("上下架控制/其他信息")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 col-sm-3 control-label label-require"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("上架时间\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    attrs: {
      "for": "AuditPassOnline"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scheduleOnlineType),
      expression: "model.scheduleOnlineType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "id": "AuditPassOnline",
      "type": "radio",
      "required": "",
      "name": "scheduleOnlineType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.scheduleOnlineType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.scheduleOnlineType = "1"
      }
    }
  }), _vm._v("\n                        审核通过自动上架")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', {
    attrs: {
      "for": "periodOfValidityOnline"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scheduleOnlineType),
      expression: "model.scheduleOnlineType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "id": "periodOfValidityOnline",
      "type": "radio",
      "required": "",
      "name": "scheduleOnlineType",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.model.scheduleOnlineType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.model.scheduleOnlineType = "2"
      }
    }
  }), _vm._v("\n                        有效期始自动上架")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scheduleOnlineType),
      expression: "model.scheduleOnlineType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "type": "radio",
      "required": "",
      "name": "scheduleOnlineType",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.model.scheduleOnlineType, "3")
    },
    on: {
      "__c": function($event) {
        _vm.model.scheduleOnlineType = "3"
      }
    }
  }), _vm._v("\n                        手动上架")])]), _vm._v(" "), _c('div', {
    staticClass: "radio",
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('label', {
    attrs: {
      "for": "specifyDateOnline"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scheduleOnlineType),
      expression: "model.scheduleOnlineType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "id": "specifyDateOnline",
      "type": "radio",
      "required": "",
      "name": "scheduleOnlineType",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.model.scheduleOnlineType, "4")
    },
    on: {
      "__c": function($event) {
        _vm.model.scheduleOnlineType = "4"
      }
    }
  }), _vm._v("\n                        指定日期上架\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "w200 inline-block"
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.model.scheduleOnlineTime,
      "disabled": _vm.model.scheduleOnlineType != 4
    },
    model: {
      value: (_vm.model.scheduleOnlineTime),
      callback: function($$v) {
        _vm.model.scheduleOnlineTime = $$v
      },
      expression: "model.scheduleOnlineTime"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.scheduleOnlineType == 4 && !_vm.model.scheduleOnlineTime),
      expression: "needValidation && model.scheduleOnlineType==4 && !model.scheduleOnlineTime"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("请选择上架日期")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 col-sm-3 control-label label-require"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("\n                下架时间\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scheduleOfflineType),
      expression: "model.scheduleOfflineType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan,
      "type": "radio",
      "required": "",
      "name": "scheduleOfflineType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.scheduleOfflineType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.scheduleOfflineType = "1"
      }
    }
  }), _vm._v("\n                        " + _vm._s(_vm.model.useDateMode == 0 ? '有效期' : '价格日历期限') + "已过自动下架")])]), _vm._v(" "), _c('div', {
    staticClass: "radio",
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scheduleOfflineType),
      expression: "model.scheduleOfflineType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan,
      "type": "radio",
      "name": "scheduleOfflineType",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.model.scheduleOfflineType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.model.scheduleOfflineType = "2"
      }
    }
  }), _vm._v("\n                        指定下架时间")]), _vm._v(" "), _c('div', {
    staticClass: "w200 inline-block"
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.model.scheduleOfflineTime,
      "disabled": _vm.model.scheduleOfflineType == 1 || (_vm.mode == 'readonly' && !_vm.isTuan)
    },
    model: {
      value: (_vm.model.scheduleOfflineTime),
      callback: function($$v) {
        _vm.model.scheduleOfflineTime = $$v
      },
      expression: "model.scheduleOfflineTime"
    }
  })], 1), _vm._v(" "), _c('input', {
    staticClass: "input-w-3 inline-block",
    attrs: {
      "readonly": "",
      "disabled": "",
      "type": "text",
      "name": "scheduleOfflineType",
      "value": "00:00"
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.scheduleOfflineType == 2 && !_vm.model.scheduleOfflineTime),
      expression: "needValidation && model.scheduleOfflineType==2 && !model.scheduleOfflineTime"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("请选择下架日期")])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.extra.isBD || _vm.model.IAmTheatre),
      expression: "extra.isBD || model.IAmTheatre"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 col-sm-3 control-label label-require"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("\n                是否单独售卖\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.sellType),
      expression: "model.sellType"
    }],
    attrs: {
      "type": "radio",
      "required": "",
      "name": "sellType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.sellType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.sellType = "1"
      }
    }
  }), _vm._v("\n                        可单独售卖")])]), _vm._v(" "), _c('div', {
    staticClass: "radio",
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.sellType),
      expression: "model.sellType"
    }],
    attrs: {
      "id": "ManualOnline222",
      "type": "radio",
      "required": "",
      "name": "sellType",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.model.sellType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.model.sellType = "2"
      }
    }
  }), _vm._v("\n                        用于打包，不可单独售卖")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.sellType == 2),
      expression: "model.sellType==2"
    }],
    staticClass: "annotate"
  }, [_vm._v("选择后, 产品不会被用户看到和单独购买。支持单独售卖的产品请勿选")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.model.IAmTheatre && _vm.extra.isBD),
      expression: "!model.IAmTheatre && extra.isBD"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 col-sm-3 control-label label-require"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("\n                是否上传附件\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.needSpecialAuthFile),
      expression: "model.needSpecialAuthFile"
    }],
    attrs: {
      "type": "radio",
      "required": "",
      "name": "needSpecialAuthFile",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.model.needSpecialAuthFile, "true")
    },
    on: {
      "__c": function($event) {
        _vm.model.needSpecialAuthFile = "true"
      }
    }
  }), _vm._v("\n                        需要")])]), _vm._v(" "), _c('div', {
    staticClass: "radio",
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.needSpecialAuthFile),
      expression: "model.needSpecialAuthFile"
    }],
    attrs: {
      "type": "radio",
      "required": "",
      "name": "needSpecialAuthFile",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.model.needSpecialAuthFile, "false")
    },
    on: {
      "__c": function($event) {
        _vm.model.needSpecialAuthFile = "false"
      }
    }
  }), _vm._v("\n                        不需要")])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.needSpecialAuthFile === 'true' || _vm.model.needSpecialAuthFile === true),
      expression: "model.needSpecialAuthFile==='true' || model.needSpecialAuthFile===true"
    }]
  }, [_c('div', {
    staticClass: "pdt9 tip icon-info lh14"
  }, [_vm._v("\n                        重要提示："), _c('br'), _vm._v("   \n                        1. 请将已走完特批流程的截图上传附件；若特批流程未完成，不能提交审核；"), _c('br'), _vm._v("   \n                        2. 上传的附件名称需与特批流程名称一致，若流程中有多图，请为图片增加序号以明确顺序（如，二次预约特批-1.ipg）"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "pdt9"
  }, [_c('custom-upload', {
    attrs: {
      "url": _vm.upload.url,
      "file-name": 'file',
      "is-multiple": false,
      "max-limit": _vm.upload.maxImgLength,
      "thumbnail-mode": true,
      "show-file-list": false,
      "type": 'imageList',
      "default-file-list": _vm.model.specialAuthPicsShow,
      "fileLimitSize": 2097152,
      "enable-head-image": false
    },
    on: {
      "on-max-limit": _vm.upload.onMaxLimit,
      "on-error": _vm.upload.onError,
      "on-success": _vm.upload.onSuccess,
      "on-delete": _vm.upload.onDelete,
      "on-file-size-max-limit": _vm.upload.onSizeLimited
    }
  })], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.extra.isBD && _vm.model.needSpecialAuthFile == 'true' && _vm.model.specialAuthPics.length < 1),
      expression: "needValidation && extra.isBD && model.needSpecialAuthFile=='true' && model.specialAuthPics.length < 1"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                        请上传附件")])])])]), _vm._v(" "), (!_vm.model.IAmTheatre && (_vm.extra.isBD || _vm.account.accountType == 1) && _vm.subAccounts.length) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-2 control-label"
  }, [_vm._v("关联子账号:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-item"
  }, [_vm._l((_vm.subAccounts), function(subAccount) {
    return (_vm.ticketSubAccount(subAccount, 'all')) ? _c('label', [_c('input', {
      attrs: {
        "type": "checkbox",
        "checked": "",
        "disabled": "",
        "title": subAccount.accountName
      }
    }), _vm._v("\n                    " + _vm._s(subAccount.accountName) + "\n                ")]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.subAccounts), function(subAccount) {
    return (_vm.ticketSubAccount(subAccount, 'single')) ? [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.model.bindedBizAccountId),
        expression: "model.bindedBizAccountId"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": subAccount.accountId == _vm.account.userId,
        "title": subAccount.accountName
      },
      domProps: {
        "value": subAccount.accountId,
        "checked": Array.isArray(_vm.model.bindedBizAccountId) ? _vm._i(_vm.model.bindedBizAccountId, subAccount.accountId) > -1 : (_vm.model.bindedBizAccountId)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.model.bindedBizAccountId,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = subAccount.accountId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.model.bindedBizAccountId = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.model.bindedBizAccountId = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.model.bindedBizAccountId = $$c
          }
        }
      }
    }), _vm._v("\n                        " + _vm._s(subAccount.accountName) + "\n                    ")])] : _vm._e()
  }), _vm._v(" "), _c('label', [_c('button', {
    staticClass: "btn btn-link no-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectAllAccounts(_vm.subAccountAll)
      }
    }
  }, [_vm._v("全选\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "annotate"
  }, [_vm._v("\n                    被选中的子账号,将根据权限设置结果,对该产品拥有上单或验证权限\n                ")])], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bottom-filled"
  }), _vm._v(" "), _c('sort-dialog', {
    attrs: {
      "model": _vm.sortDialog.model,
      "show": _vm.sortDialog.show
    },
    on: {
      "update:show": function($event) {
        _vm.sortDialog.show = $event
      },
      "saveSort": _vm.sortDialog.save
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cac3229","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/product/item/Price.vue
// module id = 568
// module chunks = 0